import { cn } from "@/lib/cn";

interface KpiReadoutProps {
  label: string;
  value: string;
  suffix?: string;
  accent?: boolean;
  sparkline?: number[];
}

export function KpiReadout({ label, value, suffix, accent, sparkline }: KpiReadoutProps) {
  return (
    <div className="bg-surface p-4">
      <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.13em] text-navy-300">
        {label}
      </div>
      <div
        data-kpi-value
        className={cn(
          "mt-2 font-mono text-[32px] font-semibold leading-none tracking-tight tabular-nums",
          accent ? "text-accent" : "text-navy-700 dark:text-zinc-100",
        )}
      >
        {value}
        {suffix && <small className="ml-0.5 text-sm font-medium text-muted">{suffix}</small>}
      </div>
      {sparkline && sparkline.length > 0 && (
        <div className="mt-2 flex items-end gap-[3px] h-[18px]">
          {sparkline.map((h, i) => (
            <span
              key={`spark-${i}-${h}`}
              className="w-[5px] rounded-[1px] bg-teal-300 opacity-85"
              style={{ height: `${Math.max(h, 10)}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
